export default __webpack_public_path__ + "static/media/pig-purple.034b464b.svg";